<svg
  class="file-icon"
  width="19"
  height="22"
  viewBox="0 0 19 22"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    [attr.fill]="fillColor"
    d="M14.25 12.8333C14.25 13.0765 14.1499 13.3096 13.9717
                13.4815C13.7936 13.6534 13.5519 13.75 13.3 13.75H5.69999C5.44804
                13.75 5.2064 13.6534 5.02824 13.4815C4.85008 13.3096 4.74999
                13.0765 4.74999 12.8333C4.74999 12.5902 4.85008 12.3571 5.02824
                12.1852C5.2064 12.0133 5.44804 11.9167 5.69999
                11.9167H13.3C13.5519 11.9167 13.7936 12.0133 13.9717
                12.1852C14.1499 12.3571 14.25 12.5902 14.25 12.8333ZM10.45
                15.5833H5.69999C5.44804 15.5833 5.2064 15.6799 5.02824
                15.8518C4.85008 16.0237 4.74999 16.2569 4.74999 16.5C4.74999
                16.7431 4.85008 16.9763 5.02824 17.1482C5.2064 17.3201 5.44804
                17.4167 5.69999 17.4167H10.45C10.7019 17.4167 10.9436 17.3201
                11.1217 17.1482C11.2999 16.9763 11.4 16.7431 11.4 16.5C11.4
                16.2569 11.2999 16.0237 11.1217 15.8518C10.9436 15.6799 10.7019
                15.5833 10.45 15.5833ZM19 9.61126V17.4167C18.9985 18.6318
                18.4975 19.7967 17.6071 20.656C16.7166 21.5152 15.5093 21.9985
                14.25 22H4.74999C3.49068 21.9985 2.28338 21.5152 1.39291
                20.656C0.502437 19.7967 0.00150846 18.6318 0
                17.4167V4.58335C0.00150846 3.36822 0.502437 2.20328 1.39291
                1.34405C2.28338 0.484829 3.49068 0.00147666 4.74999
                2.11279e-05H9.03924C9.91288 -0.00214855 10.7783 0.16281 11.5854
                0.485358C12.3926 0.807907 13.1255 1.28165 13.7417
                1.87919L17.0515 5.07468C17.6712 5.6689 18.1624 6.37585 18.4969
                7.15457C18.8313 7.9333 19.0023 8.76832 19 9.61126ZM12.3984
                3.17535C12.0995 2.89592 11.7638 2.65553 11.4
                2.46035V6.41668C11.4 6.6598 11.5001 6.89295 11.6782
                7.06486C11.8564 7.23677 12.098 7.33335 12.35
                7.33335H16.4502C16.2478 6.98244 15.9983 6.65881 15.7082
                6.37085L12.3984 3.17535ZM17.1 9.61126C17.1 9.46001 17.0696
                9.31518 17.0553 9.16668H12.35C11.5941 9.16668 10.8692 8.87695
                10.3347 8.36122C9.80025 7.8455 9.49999 7.14603 9.49999
                6.41668V1.87644C9.34609 1.86269 9.19504 1.83335 9.03924
                1.83335H4.74999C3.99413 1.83335 3.26922 2.12308 2.73474
                2.63881C2.20026 3.15453 1.9 3.85401 1.9 4.58335V17.4167C1.9
                18.146 2.20026 18.8455 2.73474 19.3612C3.26922 19.8769 3.99413
                20.1667 4.74999 20.1667H14.25C15.0058 20.1667 15.7308 19.8769
                16.2652 19.3612C16.7997 18.8455 17.1 18.146 17.1
                17.4167V9.61126Z"
  />
</svg>
